import queryString from 'query-string';
import http from '@/http';
import httpNova from '../httpNovoEndpoint';


export default {

    // CRUD
    list() {
        return http.get('/demands');
    },
    // consulta a demanda selecionada no Grid tela Demadas
    // (tela src\components\demands\Edit.vue fetchDemand).
    fetch(id) {
        return http.get(`/demands/${id}`);
    },
    save(form) {
        return http.post('/demands', form);
    },
    update(id, form) {
        return http.put(`/demands/${id}/`, form);
    },

    // Actions
    approve(id, form) {
        return http.put(`/demands/${id}/approve`, form);
    },
    cancel(id, form) {
        return http.put(`/demands/${id}/cancel`, form);
    },
    reject(id, form) {
        return http.put(`/demands/${id}/reject`, form);
    },
    plan(id, form) {
        return http.put(`/demands/${id}/planning`, form);
    },
    request(id) {
        return http.put(`/demands/${id}/request`);
    },
    deliver(id, form) {
        return http.post(`/demands/${id}/deliver`, form);
    },

    // Other
    findByCode(form) {
        return http.get(`/demands/findByCode?${queryString.stringify(form)}`);
    },
    search(form) {
        return http.get(`/demands/search?${queryString.stringify(form)}`);
    },
    findByRequest(form) {
        return httpNova.get(`/Demandas/BuscaDemandasPorSolicitante?cdUsuario=${form}`);
    },
    findByCreator(form) {
        return httpNova.get(`/Demandas/BuscaDemandasPorCriador?cdUsuario=${form}`);
    },
    findByOwner(form) {
        return httpNova.get(`/Demandas/BuscaDemandasPorResponsavel?cdUsuario=${form}`);
    },
    searchByFilter(form) {
        const ret = httpNova.get(`/Demandas/BuscaDemandasPesquisa?${queryString.stringify(form)}`);
        return ret;
    },
    getForGrid() {
        const ret = httpNova.get(`/Demandas/BuscaDemandasGrid`);
        return ret;
    },
    getEvaluatedForGrid(officeId) {
        const ret = httpNova.get(`/Demandas/BuscaDemandasSecretariaAvaliadas?cdSecretaria=${officeId}`);
        return ret;
    },
    getDemandComments(demandId) {
        const ret = httpNova.get(`/Demandas/BuscaComentariosDemanda?cdDemanda=${demandId}`);
        return ret;
    }
};


// WEBPACK FOOTER //
// ./src/api/demands.js